var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatarSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F77417;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.8,76.4c13.8-14.8,13-37.9-1.7-51.7s-37.9-13-51.7,1.7c-13.1,14.1-13.1,35.9,0,50c0.1,0.1,0.2,0.3,0.3,0.4 c13.9,14.6,37,15.1,51.6,1.2c0.4-0.4,0.8-0.8,1.2-1.2C77.6,76.7,77.7,76.5,77.8,76.4z M51.1,18.1c18.4,0,33.3,14.9,33.3,33.4 c0,7.7-2.6,15.1-7.5,21c-2.4-4.9-6.1-8.9-10.8-11.8c-1.5-0.9-3.4-0.9-4.9,0.1c-6.1,4-14,4-20.1-0.1c-1.5-1-3.4-1.1-4.9-0.2 c-4.7,2.8-8.5,7-11,11.9c-11.6-14.3-9.5-35.3,4.8-46.9C36,20.8,43.4,18.1,51.1,18.1z M27.6,75.1c2.1-4.9,5.7-9,10.3-11.8 c0.5-0.3,1-0.2,1.4,0.1c7.2,4.8,16.5,4.8,23.7,0.1c0.4-0.3,1-0.3,1.4-0.1c4.5,2.8,8,6.8,10.1,11.7C61.5,88,40.6,88,27.6,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,59.7c8.4,0,15.3-6.8,15.3-15.3s-6.8-15.3-15.3-15.3c-8.4,0-15.3,6.8-15.3,15.3c0,0,0,0,0,0 C36,52.8,42.8,59.7,51.2,59.7z M51.2,32.4c6.7,0,12,5.4,12,12s-5.4,12-12,12c-6.7,0-12-5.4-12-12c0,0,0,0,0,0 C39.2,37.8,44.6,32.4,51.2,32.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatarSelected);
export default __webpack_public_path__ + "static/media/Icon_Avatar_Selected.0859cccca4d9557d090bcf415c6a123b.svg";
export { ForwardRef as ReactComponent };